import * as React from 'react';
import { Component, ReactNode } from 'react';
import * as PropTypes from 'prop-types';
import { IMenuCardPlan } from './types';
import { PriceLabelUI as PriceLabel } from '../../components/PriceLabel/PriceLabelUI';
import CardActionButtonUI from '../../components/CardActionButton/CardActionButtonUI';
import MenuProductImage from './MenuProductImage';
import MenuProductDetails from './MenuProductDetails';

const CardActionButton = CardActionButtonUI;

import * as Types from './actions/actionTypes';

export interface IMenuProductCardUIStateProps {
    cardHeading?: string;
    cardState?: string;
    errorMessage?: string;
    id?: string;
    isExpanded?: boolean;
    isSelected?: boolean;
    media?: any;
    secondaryText?: string;
    showCardImage?: boolean;
    showVideoLink?: boolean;
    fullDetails?: string;
    isShowDetailsOpen?: any;
    rawId?: string;
    isRated?: boolean;
    plans: IMenuCardPlan[];
    terms: number[];
    mileages: number[];
    selectedMileage: number;
    selectedPlan: string;
    selectedTerm: number;
    selectedDeductible: number;
    totalPrice?: number;
    monthlyPrice?: number;
    categoryCode?: string;
    dealerPhone?: string;
    coverageName?: string;
    isPriceEnable?: boolean;
    imagePlaceHolder?: string;
    vppMonthlyPaymentLabeled?: string;
    isVppMonthlyPaymentEnabled?: boolean;
    isMenuPricingEnabled?: boolean;
    isCashOffer?: boolean;
    offerType?: string;
    isMenuPaymentsDisclaimerEnabled?: boolean;
    children?: ReactNode;
}

export interface IMenuProductCardUIDispatchProps {
    onAddClick?: { () };
    onVideoLinkClick?: { () };
    onTermChange?: { (term: number) };
    onMileageChange?: { (mileage: number) };
    onToggleDetailsView?: { (id: string, isShowing: boolean, categoryCode: string) };
}

export interface IMenuProductCardUIProps extends IMenuProductCardUIStateProps, IMenuProductCardUIDispatchProps {
}

export interface IMenuProductCardUIState {
}

export default class MenuProductCardUI extends Component<IMenuProductCardUIProps, IMenuProductCardUIState> {

    static propTypes = {
        cardHeading: PropTypes.string,
        cardState: PropTypes.string,
        id: PropTypes.string,
        isExpanded: PropTypes.bool,
        isSelected: PropTypes.bool,
        media: PropTypes.any,
        secondaryText: PropTypes.string,
        showCardImage: PropTypes.bool,
        showVideoLink: PropTypes.bool,
        fullDetails: PropTypes.string,
        onToggleDetailsView: PropTypes.func,
        isShowDetailsOpen: PropTypes.bool,
        rawId: PropTypes.string,
        isRated: PropTypes.bool,
        categoryCode: PropTypes.string
    };

    static defaultProps = {
        cardHeading: '',
        cardState: '',
        id: '',
        isSelected: false,
        media: '',
        secondaryText: '',
        showCardImage: true,
        showVideoLink: true,
        fullDetails: '',
        isRated: true
    };

    constructor(props) {
        super(props);
    }

    handleClick() {
    }

    handleAddClick() {
        if (this.props.onAddClick) {
            this.props.onAddClick();
        }
    }

    getCardImage(showCardImage: boolean) {
        if (!showCardImage) {
            return null;
        }
        const {
            media = [''],
            imagePlaceHolder = ''
        } = this.props;
        return (
            <MenuProductImage imageUrl={media[0].url} imagePlaceHolder={imagePlaceHolder} />
        );
    }

    handleVideoLinkClick() {
        if (this.props.onVideoLinkClick) {
            this.props.onVideoLinkClick();
        }
    }

    getVideoLink(showVideoLink: boolean) {
        if (!showVideoLink) {
            return null;
        }
        const media = this.props.media || [''];
        return (
            <span className="watch-video-link" onClick={() => { this.handleVideoLinkClick(); }}>
                <a>Watch Video</a>
            </span>
        );
    }

    handleViewDetailsClick(id) {
        this.props.onToggleDetailsView(id, !this.props.isShowDetailsOpen, this.props.categoryCode);
    }

    handleTermChange(term: number) {
        if (this.props.onTermChange) {
            this.props.onTermChange(term);
        }
    }

    handleMileageChange(mileage: number) {
        if (this.props.onMileageChange) {
            this.props.onMileageChange(mileage);
        }
    }

    handleNoMilesSelected() {
        return this.props.selectedMileage === null ?
            <div>Select a mileage above to add this vehicle protection product.</div>
            :
            '';
    }

    createButtonText(isRated: boolean = false, isShowDetailsOpen: boolean = false, terms: number[] = []): string {
        let buttonText = 'Add';
        if (isRated && !isShowDetailsOpen && terms.length) {
            buttonText = 'Choose Terms';
        }
        return buttonText;
    }

    showCallForPricing(errorMessage: string = '', totalPrice: number = null): boolean {
        let callForPricing = false;
        // tslint:disable-next-line: no-boolean-literal-compare
        if ((errorMessage || !totalPrice) && this.props.isPriceEnable === false) {
            callForPricing = true;
        }
        return callForPricing;
    }

    whatHandlerUseOnClickButton(terms: number[] = []): boolean {
        return !this.props.isShowDetailsOpen && !this.props.isSelected && this.props.isRated && terms.length > 0;
    }

    render() {
        const {
            cardHeading,
            errorMessage,
            secondaryText,
            showCardImage,
            showVideoLink,
            fullDetails,
            isShowDetailsOpen,
            isRated,
            terms,
            isSelected,
            plans,
            totalPrice,
            dealerPhone,
            vppMonthlyPaymentLabeled,
            isVppMonthlyPaymentEnabled,
            isMenuPricingEnabled,
            isCashOffer: isCashOffer,
            offerType,
            isMenuPaymentsDisclaimerEnabled
        } = this.props;
        const cardImage = this.getCardImage(showCardImage);
        const videoLink = this.getVideoLink(showVideoLink);
        const className = isRated ? 'dr-ui-menu-product-card dr-ui-rated-menu-product' : 'dr-ui-menu-product-card';
        const spinner = this.props.children && (this.props.children as any).key ?
            <div key={(this.props.children as any).key + Math.random()}>{this.props.children}</div> : '';

        const buttonText = this.createButtonText(isRated, isShowDetailsOpen, terms);

        const handleButtonClick = this.whatHandlerUseOnClickButton(terms) ?
            () => this.handleViewDetailsClick(this.props.rawId) :
            () => this.handleAddClick();

        const actionBtn = (
            <CardActionButton
                isSelected={isSelected}
                buttonText={buttonText}
                onClick={handleButtonClick}
                disabled={this.props.selectedMileage === null ? true : false}
            />
        );

        const priceLabel = (
            <PriceLabel
                className="dr-ui-package-total"
                price={totalPrice}
                vppMonthlyPaymentLabeled={vppMonthlyPaymentLabeled}
                hasError={this.showCallForPricing(errorMessage, totalPrice)}
                dealerPhone={dealerPhone}
                isVppMonthlyPaymentEnabled={isVppMonthlyPaymentEnabled}
                isCashOffer={isCashOffer}
                offerType={this.props.offerType}
                isMenuPaymentsDisclaimerEnabled={this.props.isMenuPaymentsDisclaimerEnabled}
            />);

        const header = (<div className="header">{cardHeading}</div>);
        const { coverageName } = this.props;

        const secondText = (
            <div className="secondary">
                <div className="secondary-text">
                    {isShowDetailsOpen ? null : secondaryText}
                    <MenuProductDetails
                        errorMessage={errorMessage}
                        fullDetails={fullDetails}
                        isShowDetailsOpen={isShowDetailsOpen}
                        isRated={isRated}
                        cardId={this.props.id}
                        plans={plans}
                        terms={terms}
                        mileages={this.props.mileages}
                        onTermChange={
                            (term) => {
                                // There's a bug that causes the term change to trigger twice, but we only
                                // want to trigger it if the term actually changes:
                                if (term !== this.props.selectedTerm) {
                                    this.handleTermChange(term);
                                }
                            }
                        }
                        onMileageChange={
                            (mileage) => {
                                // There's a bug that causes the mileage change to trigger twice, but we only
                                // want to trigger it if the mileage actually changes:
                                if (mileage !== this.props.selectedMileage) {
                                    this.handleMileageChange(mileage);
                                }
                            }
                        }
                        selectedTerm={this.props.selectedTerm}
                        selectedMileage={this.props.selectedMileage}
                        selectedDeductible={this.props.selectedDeductible}
                        mapUnlimitedToMiles={{ Unlimited: null }}
                        coverageName={coverageName}
                    />
                    {this.handleNoMilesSelected()}
                </div>
            </div>
        );

        const details = (
            <div className={`${fullDetails || isRated ? 'expandable' : ''} action-buttons`}>
                <div className={`${fullDetails || isRated ? 'view-details-button' : 'hidden'}`}>
                    <a className={`fa ${isShowDetailsOpen ? 'fa-minus-circle' : 'fa-plus-circle'}`} aria-hidden="true">
                        <span
                            className="viewDetailsLink"
                            onClick={() => { this.handleViewDetailsClick(this.props.rawId); }}>
                            {isShowDetailsOpen ? ' Hide Details' : ' View Details'}
                        </span>
                    </a>
                </div>
            </div>
        );

        const media = (
            <div className="card-image">
                {cardImage}
                {videoLink}
            </div>
        );

        const classNameForPriceBox = isVppMonthlyPaymentEnabled
            ? 'pull-left dr-ui-vpp-price-box'
            : 'pull-left';

        // TODO: Refactor later to move showPrice out
        const showPrice = (isMobile: boolean, isMenuPricingEnabled: boolean) => {
            let priceElement: React.ReactNode;

            if (isMenuPricingEnabled) {
                switch (isMobile) {
                    case true:
                        priceElement = (
                            <div className={classNameForPriceBox}>
                                {priceLabel}
                            </div>
                        );
                        break;
                    default:
                        priceElement = priceLabel;
                        break;
                }
            }

            return priceElement;
        };

        return (
            <div id={this.props.id} className={className} onClick={() => { this.handleClick(); }}>
                {/* mobile responsive configuration */}
                <div className="d-md-none card-text">
                    {header}
                    <div className="dr-ui-product-container-media">
                        {media}
                    </div>
                    <div className="dr-ui-product-container-text">
                        {secondText}
                        {spinner}
                    </div>
                    <div className="row dr-ui-product-container-price-and-add">
                        {showPrice(true, isMenuPricingEnabled)}
                        <div className="pull-right">
                            {actionBtn}
                        </div>
                    </div>
                    <div className="row dr-ui-product-container-expand-details">
                        {details}
                    </div>
                </div>
                {/* desktop responsive configuration */}
                <div className="d-sm-none card-text">
                    <div className="dr-ui-product-container">
                        <div className="">
                            {media}
                        </div>
                        <div className="dr-ui-product-container-text">
                            {header}

                            {secondText}

                            {spinner}

                            {details}
                        </div>
                        <div className="dr-ui-product-container-price-add-btn">
                            {showPrice(false, isMenuPricingEnabled)}
                            {actionBtn}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
